import {
  getMonthAbbreviation,
  getShortMonthNameFromNumber,
  onlineFileExists,
  urlFriendlyString,
} from "@/utils";

const { VITE_STATIC_URL } = import.meta.env;
export const exportableStatementsTest = async (
  filenamePrefix: string,
  customerName: string,
  fileNamePostfix: string,
  energyType: string,
  date: string,
  gettext: (key: string) => string,
) => {
  const folder = "testing";
  const returnArray = [];
  let optionLabel = gettext("Test report");
  let optionKey = "export-statement";
  switch (filenamePrefix) {
    case "energy-statement":
      optionLabel = gettext("Test Energy Report");
      optionKey = "energy-report";
      break;
    case "climate-statement":
      optionLabel = gettext("Test Climate Report");
      optionKey = "climate-report";
      break;
    case "spot-price-statement":
      optionLabel = gettext("Test Sport Price Report");
      optionKey = "spot-price-report";
      break;
    default:
      // Do nothing
      break;
  }

  if (date) {
    if (filenamePrefix === "spot-price-statement") {
      for (let i = 1; i < 13; i++) {
        const monthName = getMonthAbbreviation(i);
        const monthNameTranslated = getShortMonthNameFromNumber(i);
        const newOptionLabel = optionLabel + ` (${monthNameTranslated})`;
        const newOptionKey = `${optionKey}-${monthName}`;
        const year = new Date(date).getFullYear();
        const fileName = urlFriendlyString(
          filenamePrefix +
            "-" +
            customerName +
            fileNamePostfix +
            "-" +
            energyType +
            "-" +
            monthName +
            "-" +
            year,
        );
        const returnObj = await exportableStatementItem(
          newOptionLabel,
          newOptionKey,
          fileName,
        );
        if (returnObj) {
          returnArray.push(returnObj);
        }
      }
    } else {
      const year = new Date(date).getFullYear();
      const fileName = urlFriendlyString(
        filenamePrefix +
          "-" +
          customerName +
          fileNamePostfix +
          "-" +
          energyType +
          "-" +
          year,
      );
      const returnObj = await exportableStatementItem(
        optionLabel,
        optionKey,
        fileName,
      );
      if (returnObj) {
        returnArray.push(returnObj);
      }
    }
  } else {
    const fileName = urlFriendlyString(
      filenamePrefix + "-" + customerName + fileNamePostfix + "-" + energyType,
    );
    const returnObj = {
      label: optionLabel,
      key: optionKey,
      url: `${VITE_STATIC_URL}/${folder}/${fileName}.xlsx`,
    };
    if (returnObj) {
      returnArray.push(returnObj);
    }
  }

  return returnArray;
};

const exportableStatementItem = async (
  optionLabel: string,
  optionKey: string,
  fileName: string,
) => {
  const folder = "testing";
  let returnObj;

  const obj = {
    label: optionLabel,
    key: optionKey,
    url: `${VITE_STATIC_URL}/${folder}/${fileName}.xlsx`,
  };

  const fileFound = await onlineFileExists(
    `${VITE_STATIC_URL}/${folder}/${fileName}.xlsx`,
  );

  if (fileFound) {
    returnObj = obj;
  } else {
    returnObj = null;
  }

  return returnObj;
};
